import { http } from '@/utils/http';
import Store from '@/store/index';

// mongodb 相关信息
export const reqFetchMongodbInfo = () =>
{
  let param = {
    ConnToken: Store.getters['source/connToken']
  };
  return http.request({
    url: `/v1/mongo/detail`,
    method: 'GET',
    params: param
  });
}

/**
 * 数据库
 */
// 获取数据库列表
export const reqFetchDatabases = () =>
  http.request({
    url: `/v1/mongo/listsDb`,
    method: 'GET',
    params: {
      ConnToken: Store.getters['source/connToken']
    }
  });

// 创建数据库
export const reqCreateDatabase = ( data ) =>
  http.request({
    url: `/v1/mongo/createDb `,
    method: 'POST',
    data: data
  });

/**
 * 命令
 */
// 执行命令
export const reqExecuteCommand = data =>
  http.request({
    url: `/v1/mongo/exec`,
    method: 'POST',
    data
  });
